import dayjs from "dayjs";

export default function getDateRange(period, type) {
  const today = dayjs();
  let startDate;
  let scale = "daily";

  switch (period) {
    case 0:
      startDate = today;
      break;
    case 0.25:
      startDate = today.subtract(7, "day").add(1, "day");
      break;
    case 1:
      startDate = today.subtract(30, "day").add(1, "day");
      break;
    case 6:
      startDate = today.subtract(6, "month").startOf("month");
      scale = "monthly";
      break;
    case 12:
      startDate = today.subtract(12, "month").startOf("month");
      scale = "monthly";
      break;
    default:
      throw new Error("Invalid period value");
  }

  const result = {
    end_date: today.format("YYYY-MM-DD"),
    start_date: startDate.format("YYYY-MM-DD"),
  };

  if (type === "event-detailed") {
    result.scale = scale;
  }

  return result;
}
